import { SET_GRAPH_METRICS } from './actionTypes';

export const setGraphMetrics = metrics => ({
    type: SET_GRAPH_METRICS,
    payload: metrics,
});
